import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from '../constants';

export const pushkinMetric = stats.prefix(`packages.assistant_realtime.${METRICS_PREFIX}`);
